import React from 'react'

var Error = React.createClass({
  componentDidMount: function(){
    if(this.props.message) scrollTo(document.getElementsByClassName('signup-feedback')[0], 0, 600)
  },
  render: function(){
    if(!this.props.message) return false
    return (
      <p className="alert signup-feedback alert-danger" style={{display: 'block'}}>{this.props.message}</p>
    )
  }
})

module.exports = Error



// WEBPACK FOOTER //
// ./src/components/Error.jsx